// extracted by mini-css-extract-plugin
var _1 = "BirdviewRowAddress-moduleaddress__wawqV";
var _2 = "BirdviewRowAddress-moduleassignee__RP3db BirdviewRowAddress-moduletext__HYgbC";
var _3 = "BirdviewRowAddress-moduledot__CEo9M";
var _4 = "BirdviewRowAddress-moduleflat__OY7NF BirdviewRowAddress-moduletext__HYgbC";
var _5 = "BirdviewRowAddress-moduletext__HYgbC";
export { _1 as "address", _2 as "assignee", _3 as "dot", _4 as "flat", _5 as "text" }
